module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.primitive) ? _c('objectTreeNodePrimitive', {
    attrs: {
      "type": _vm.type
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _c('objectTreeNodeComplex', {
    attrs: {
      "type": _vm.type,
      "primary": _vm.primary
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d18ba082!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-object-view/ObjectTreeNode.vue
// module id = 1554
// module chunks = 2